// Appels publics à la fonction Supabase proposal-view (accès par jeton, sans compte).
const FN_URL =
  process.env.REACT_APP_SUPABASE_FUNCTIONS_URL ||
  `${process.env.REACT_APP_SUPABASE_URL}/functions/v1`;

export async function callProposal(payload) {
  const res = await fetch(`${FN_URL.replace(/\/$/, "")}/proposal-view`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
      Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
    },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error || "Une erreur est survenue.");
    err.status = res.status;
    throw err;
  }
  return data;
}

export function newProposalToken() {
  const bytes = new Uint8Array(24);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export const REACTION_LABELS = {
  interested: "Intéressé(e)",
  not_for_me: "Pas pour moi",
  question: "J'ai une question",
};
